var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.product
    ? _c(
        "ul",
        {
          class: [
            "product-details",
            {
              "mb-0 modal-product-details product-details":
                _vm.upsellCardType === "mobile-us-product-upsell",
              "pl-0": _vm.upsellCardType === "mobile-us-product-upsell",
              "p-0 modal-product-details":
                _vm.upsellCardType === "us-product-upsell",
              "mb-4 mt-4": _vm.upsellCardType === "row-product-upsell",
            },
          ],
        },
        [
          !_vm.usBooking ||
          (_vm.usBooking &&
            _vm.upsellCardType === "us-product-upsell" &&
            _vm.insuranceExcessFromVehicleWithoutConversion(
              _vm.productOrVehicle,
              _vm.quote.selected_vehicle,
              _vm.vehicle
            ) > 0)
            ? _c("li", [
                _c("span", { staticClass: "w-8 text-center icon" }, [
                  _c("span", { staticClass: "inline w-8" }, [
                    _vm.upsellCardType === "row-product-upsell"
                      ? _c("img", {
                          attrs: {
                            "svg-inline": "",
                            src: _vm.icon("checkbox-border-ticked-alt"),
                          },
                        })
                      : _c("img", {
                          attrs: {
                            "svg-inline": "",
                            src: _vm.icon("checkbox-border-ticked-alt"),
                          },
                        }),
                  ]),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("PriceCard.excess_liability")) +
                      "\n        "
                  ),
                  _vm.currencyIsChanging
                    ? _c("strong", [_vm._v("…")])
                    : _vm.costIsTheSame(
                        _vm.insuranceExcessPrice,
                        _vm.productOrVehicle,
                        _vm.basicProduct
                      ) && !_vm.currencyIsChanging
                    ? _c("span", [
                        _c("strong", [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.insuranceExcessPrice(
                                  _vm.productOrVehicle,
                                  _vm.quote.selected_vehicle,
                                  _vm.vehicle
                                )
                              ) +
                              "\n            "
                          ),
                        ]),
                      ])
                    : _c("span", [
                        _c("strong", [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.insuranceExcessPrice(
                                  _vm.productOrVehicle,
                                  _vm.quote.selected_vehicle,
                                  _vm.vehicle
                                )
                              ) +
                              "\n            "
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.basicProduct &&
                        _vm.notBasicProductSelected &&
                        !_vm.usBooking
                          ? _c("span", { staticClass: "old-price" }, [
                              _vm._v(
                                "\n                (" +
                                  _vm._s(
                                    _vm.insuranceExcessPrice(
                                      _vm.basicProduct,
                                      _vm.quote.selected_vehicle,
                                      _vm.vehicle
                                    )
                                  ) +
                                  ")\n            "
                              ),
                            ])
                          : _vm._e(),
                      ]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("li", [
            _c("span", { staticClass: "w-8 text-center icon" }, [
              _c("span", { staticClass: "inline w-8" }, [
                _vm.upsellCardType === "row-product-upsell"
                  ? _c("img", {
                      attrs: {
                        "svg-inline": "",
                        src: _vm.icon("checkbox-border-ticked-alt"),
                      },
                    })
                  : _c("img", {
                      attrs: {
                        "svg-inline": "",
                        src: _vm.icon("checkbox-border-ticked-alt"),
                      },
                    }),
              ]),
            ]),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("PriceCard.security_deposit")) +
                  "\n        "
              ),
              _vm.currencyIsChanging
                ? _c("strong", [_vm._v("…")])
                : _vm.costIsTheSame(
                    _vm.insuranceDepositPrice,
                    _vm.product,
                    _vm.basicProduct
                  ) && !_vm.currencyIsChanging
                ? _c("span", [
                    _c("strong", [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.insuranceDepositPrice(
                              _vm.product,
                              _vm.quote.selected_vehicle,
                              _vm.vehicle
                            )
                          ) +
                          "\n            "
                      ),
                    ]),
                  ])
                : _c("span", [
                    _c("strong", [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.insuranceDepositPrice(
                              _vm.product,
                              _vm.quote.selected_vehicle,
                              _vm.vehicle
                            )
                          ) +
                          "\n            "
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.basicProduct &&
                    _vm.notBasicProductSelected &&
                    !_vm.usBooking
                      ? _c("span", { staticClass: "old-price" }, [
                          _vm._v(
                            "\n                (" +
                              _vm._s(
                                _vm.insuranceDepositPrice(
                                  _vm.basicProduct,
                                  _vm.quote.selected_vehicle,
                                  _vm.vehicle
                                )
                              ) +
                              ")\n            "
                          ),
                        ])
                      : _vm._e(),
                  ]),
            ]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("span", { staticClass: "w-8 text-center icon" }, [
              _c("span", { staticClass: "inline w-8" }, [
                _vm.upsellCardType === "row-product-upsell"
                  ? _c("img", {
                      attrs: {
                        "svg-inline": "",
                        src: _vm.icon("checkbox-border-ticked-alt"),
                      },
                    })
                  : _c("img", {
                      attrs: {
                        "svg-inline": "",
                        src: _vm.icon("checkbox-border-ticked-alt"),
                      },
                    }),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "span",
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("PriceCard.fuel_policy")) +
                    "\n        "
                ),
                _vm.productOrVehicle.fuel_policy == "SL"
                  ? [_vm._v(_vm._s(_vm.$t("PriceCard.like_for_like")))]
                  : _vm._e(),
                _vm._v(" "),
                _vm.productOrVehicle.fuel_policy == "FF"
                  ? [_vm._v(_vm._s(_vm.$t("PriceCard.full_to_full")))]
                  : _vm._e(),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("span", { staticClass: "w-8 text-center icon" }, [
              _c("span", { staticClass: "inline w-8" }, [
                _vm.upsellCardType === "row-product-upsell"
                  ? _c("img", {
                      attrs: {
                        "svg-inline": "",
                        src: _vm.icon("checkbox-border-ticked-alt"),
                      },
                    })
                  : _c("img", {
                      attrs: {
                        "svg-inline": "",
                        src: _vm.icon("checkbox-border-ticked-alt"),
                      },
                    }),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "span",
              [
                _vm.mileageUnit == "Miles"
                  ? [
                      _vm.productOrVehicle.mileage
                        ? [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t("PriceCard.miles_per_rental", {
                                    mileage: _vm.productOrVehicle.mileage,
                                  })
                                ) +
                                "\n        "
                            ),
                          ]
                        : _vm.vehicle && _vm.vehicle.mileage
                        ? [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t("PriceCard.miles_per_rental", {
                                    mileage: _vm.vehicle.mileage,
                                  })
                                ) +
                                "\n        "
                            ),
                          ]
                        : _vm.selectedVehicle && _vm.selectedVehicle.mileage
                        ? [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t("PriceCard.miles_per_rental", {
                                    mileage: _vm.selectedVehicle.mileage,
                                  })
                                ) +
                                "\n        "
                            ),
                          ]
                        : [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("PriceCard.unlimited_mileage")) +
                                "\n        "
                            ),
                          ],
                    ]
                  : [
                      _vm.productOrVehicle.mileage
                        ? [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t("PriceCard.km_per_rental", {
                                    mileage: _vm.productOrVehicle.mileage,
                                  })
                                ) +
                                "\n        "
                            ),
                          ]
                        : _vm.vehicle && _vm.vehicle.mileage
                        ? [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t("PriceCard.km_per_rental", {
                                    mileage: _vm.vehicle.mileage,
                                  })
                                ) +
                                "\n        "
                            ),
                          ]
                        : _vm.selectedVehicle && _vm.selectedVehicle.mileage
                        ? [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t("PriceCard.km_per_rental", {
                                    mileage: _vm.selectedVehicle.mileage,
                                  })
                                ) +
                                "\n        "
                            ),
                          ]
                        : [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t("PriceCard.unlimited_mileage_km")
                                ) +
                                "\n        "
                            ),
                          ],
                    ],
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("span", { staticClass: "w-8 text-center icon" }, [
              _c("span", { staticClass: "inline w-8" }, [
                _vm.isNonRefundable
                  ? _c("img", {
                      attrs: {
                        "svg-inline": "",
                        src: _vm.icon("checkbox-border-ticked-x"),
                      },
                    })
                  : _c("img", {
                      attrs: {
                        "svg-inline": "",
                        src: _vm.icon("checkbox-border-ticked-alt"),
                      },
                    }),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "span",
              [
                _vm.isBasicFreeCancellationVariant
                  ? [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("PriceCard.basic_free_cancellation")) +
                          "\n        "
                      ),
                    ]
                  : _vm.isNonRefundable
                  ? [_vm._v(" " + _vm._s(_vm.$t("PriceCard.non_refundable")))]
                  : _vm.hasPremiumCancellationPolicy
                  ? [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("PriceCard.free_cancellation_until")) +
                          " " +
                          _vm._s(_vm.cancellationUntil.format("DD MMM")) +
                          "\n        "
                      ),
                    ]
                  : !_vm.hasNoProducts
                  ? [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$t("PriceCard.cancellation_in_line_with")
                          ) +
                          " "
                      ),
                      _c(
                        "a",
                        {
                          attrs: { href: "#" },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              return _vm.showTermsAndConditions.apply(
                                null,
                                arguments
                              )
                            },
                          },
                        },
                        [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(_vm.$t("PriceCard.tcs")),
                            },
                          }),
                        ]
                      ),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _vm.product.type == "BAS" || _vm.hasNoProducts
            ? _c("li", [
                _c("span", { staticClass: "w-8 text-center icon" }, [
                  _c("span", { staticClass: "inline w-8" }, [
                    _c("img", {
                      attrs: {
                        "svg-inline": "",
                        src: _vm.icon("checkbox-border-ticked-x"),
                      },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  [[_vm._v(_vm._s(_vm.$t("PriceCard.non_amendable")))]],
                  2
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.product.type == "PMP"
            ? _c("li", [
                _c("span", { staticClass: "w-8 text-center icon" }, [
                  _c("span", { staticClass: "inline w-8" }, [
                    _vm.upsellCardType === "row-product-upsell"
                      ? _c("img", {
                          attrs: {
                            "svg-inline": "",
                            src: _vm.icon("checkbox-border-ticked-alt"),
                          },
                        })
                      : _c("img", {
                          attrs: {
                            "svg-inline": "",
                            src: _vm.icon("checkbox-border-ticked-alt"),
                          },
                        }),
                  ]),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("PriceCard.glass_and_tyres_covered")) +
                      "\n    "
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.product.debit_card == "Y"
            ? _c("li", [
                _c("span", { staticClass: "w-8 text-center icon" }, [
                  _c("span", { staticClass: "inline w-8" }, [
                    _vm.upsellCardType === "row-product-upsell"
                      ? _c("img", {
                          attrs: {
                            "svg-inline": "",
                            src: _vm.icon("checkbox-border-ticked-alt"),
                          },
                        })
                      : _c("img", {
                          attrs: {
                            "svg-inline": "",
                            src: _vm.icon("checkbox-border-ticked-alt"),
                          },
                        }),
                  ]),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("PriceCard.debit_card_deposit")) + "\n    "
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.product.type == "PMP"
            ? _c("li", [
                _c("span", { staticClass: "w-8 text-center icon" }, [
                  _c("span", { staticClass: "inline w-8" }, [
                    _c("img", {
                      attrs: { "svg-inline": "", src: _vm.icon("extras") },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("PriceCard.free_extras_on_collection")) +
                      "\n    "
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.product.fast_track == "Y"
            ? _c("li", [
                _c("span", { staticClass: "w-8 text-center icon" }, [
                  _c("span", { staticClass: "inline w-8" }, [
                    _vm.upsellCardType === "row-product-upsell"
                      ? _c("img", {
                          attrs: {
                            "svg-inline": "",
                            src: _vm.icon("checkbox-border-ticked-alt"),
                          },
                        })
                      : _c("img", {
                          attrs: {
                            "svg-inline": "",
                            src: _vm.icon("checkbox-border-ticked-alt"),
                          },
                        }),
                  ]),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("PriceCard.fast_track_included")) + "\n    "
                  ),
                ]),
              ])
            : _vm._e(),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }